<template>
    <div>
        <div class="searcher-container-negative mb-5">
            <!--<v-text-field
                @input="searchData($event)"
                label="Buscar curso"
                class="searcher form-control form-search"
                single-line
                hide-details
            ></v-text-field>-->
            <label for="showFilters"><input id="showFilters" class="form-check-input" type="checkbox" v-model="showFilters"> Mostrar Filtros</label>
        </div>
        <v-data-table
            :headers="headersTabs"
            :items="desserts"
            item-key="name"
            class="elevation-1 table align-middle table-courses text-center"
            :search="search"
            :items-per-page="10"
            loading
            loading-text="Cargando..."
            mobile-breakpoint="0"
            :footer-props="{
                prevIcon: 'fa-solid fa-chevron-left',
                nextIcon: 'fa-solid fa-chevron-right',
                'items-per-page-text': 'Mostrando: ',
                'items-per-page-options': [5, 10, 20, 30, 40, 50],
            }"
        >

            <template v-slot:body.prepend>
                <tr v-show="showFilters">
                    <td colspan="1"></td>
                    <td><input type="text" class="form-control" placeholder="Curso" @input="searchData($event)" v-model="busqueda.curso"></td>
                    <td><input type="text" class="form-control" placeholder="Empresa" @input="searchData($event)" v-model="busqueda.client"></td>
                    <td colspan="5"></td>
                </tr>
            </template>

            <template v-slot:item="row">
                <tr class="small">
                    <td>{{ row.item.wordpress_course_id }}</td>
                    <td style="width: 60%">
                        <div class="text-start lh-1 py-1">
                            {{ row.item.wordpress_course_title }}
                        </div>
                    </td>
                    <td width="25%">{{ row.item.countClients }}</td>
                    <td><a :href="redirect + '?course=' + row.item.id">{{ row.item.countEstudiantes }}</a></td>
                    <td>{{ row.item.countEstudiantesIniciados }}</td>
                    <td>{{ row.item.countEstudiantesEnProgreso }}</td>
                    <td>{{ row.item.countEstudiantesAprobados }}</td>
                    <td>{{ row.item.countEstudiantesReprobados }}</td>
                    <td></td>
                </tr>
            </template>
        </v-data-table>

    </div>
</template>

<script>
export default {
    props: ["headertab", "urldatacourses", "redirect"],
    data() {
        return {
            search:'',
            headersTabs: this.headertab,
            desserts: [],
            edit: [],
            showFilters: false,
            busqueda: { curso : "", client : "", tipo : "" }
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData(){
            axios.get(`${this.urldatacourses}?withUsers=true`).then((dataCourse) => {
                if(dataCourse == null) return;
                this.desserts = dataCourse.data;
            });
        },
        searchData(event){
            let search = ``;//`&search=${event}`;
            let searchByName = this.busqueda.curso != "" ? `&curso=${this.busqueda.curso}` : ``;
            let searchByEmpresa = this.busqueda.client != "" ? `&empresa=${this.busqueda.client}` : ``;
            let filters = searchByName+searchByEmpresa;
            axios.get(`${this.urldatacourses}?withUsers=true${search}${filters}`).then((dataCourse) => {
                if(dataCourse == null) return;
                this.desserts = dataCourse.data;
            });
        }
    },
};
</script>
